const EducationLevels = [
  "SECONDARY",
  "BACHELOR",
  "GRADUATE",
  "ADULT",
  "LABOUR",
  "APPRENTICESHIP",
];

export default EducationLevels;
